if ( $('header .mobile-nav li') ) {
  $('header .mobile-nav li.menu-item-has-children > a').on('click', function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('active');
  });

  $('header .main-nav li.menu-item-has-children > a').on('click', function(e) {
    e.preventDefault();
  });
}

$('.burg-con').on('click', function() {
  $('.burger').toggleClass('active');
  $('.mobile-nav').toggleClass('active');
});


$(function() {

  if ( $('header .mobile-nav li.accessability-icon') ) {
    $('header .mobile-nav li.accessability-icon a').prepend('<span class="icon icon-accessibility"></span>');
  }

})



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/_MobileMenu.js